import React from 'react';
import { Type, Smartphone, Monitor, Tablet } from 'lucide-react';
import strings from '../../data/responsiveCard.json';
import './style.css';

// Простой переводчик
const useT = (lang = 'en') => (path, fallback = '') =>
  path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), strings[lang]) ?? fallback;

export const ResponsiveCard = ({ lang = 'en' }) => {
  const t = useT(lang);

  return (
    <div className="respo-grid">
      {/* Typography Block */}
      <div className="respo-typo">
        <h3 className="card-title-small">
          <Type size={20} /> {t('titles.typography')}
        </h3>

        <ul className="respo-typo-list">
          <li className="respo-typo-item">
            <p className="respo-typo-h1 text-gradient">
              {t('typography.examples.h1.text')}
            </p>
            <span className="respo-typo-label">
              {t('typography.examples.h1.label')}
            </span>
          </li>

          <li className="respo-typo-item">
            <p className="respo-typo-h2 h2--bar">
              {t('typography.examples.h2.text')}
            </p>
            <span className="respo-typo-label">
              {t('typography.examples.h2.label')}
            </span>
          </li>

          <li className="respo-typo-item">
            <h3 className="respo-h3 h3--tag">
              <span className="tag">UI</span> {t('typography.examples.h3.ui.text')}
            </h3>
            <h3 className="respo-h3 h3--icon">
              {t('typography.examples.h3.icon.text')}
            </h3>
            <span className="respo-typo-label">
              {t('typography.examples.h3.label')}
            </span>
          </li>
        </ul>
      </div>

      {/* Responsive Block */}
      <div className="respo-responsive">
        <h3 className="card-title-small">
          <Smartphone size={20} /> {t('titles.responsive')}
        </h3>

        <div className="respo-devices">
          <div className="respo-device is-desktop" aria-label="Desktop preview">
            <Monitor size={16} className="respo-device-mark" />
            <div className="skeleton">
              <div className="bar" />
              <div className="row" />
              <div className="row" />
              <div className="row short" />
            </div>
          </div>

          <div className="respo-device is-tablet" aria-label="Tablet preview">
            <Tablet size={16} className="respo-device-mark" />
            <div className="skeleton">
              <div className="bar" />
              <div className="row" />
              <div className="row short" />
            </div>
          </div>

          <div className="respo-device is-mobile" aria-label="Mobile preview">
            <Smartphone size={16} className="respo-device-mark" />
            <div className="skeleton">
              <div className="bar" />
              <div className="row" />
              <div className="row tiny" />
            </div>
          </div>
        </div>

        <div className="respo-note">
          <span aria-hidden="true" className="sparkline"></span>
          {t('responsive.note')}
        </div>
      </div>
    </div>
  );
};
